import type { AuthorisableUser } from 'policies/entities/user';
import { ROLE } from 'services/assist-api/entities/role/roles';

/**
 * Used to make buttons blue if and *only if* they can be visible when the
 * user has the role ROLE_SITE_ADMIN. For example, the same authorisation
 * policy action can be called but without the site admin role, to check the
 * difference.
 */
export function authorisableUserWithSiteAdminRemoved(
  authorisableUser: AuthorisableUser
): AuthorisableUser {
  return {
    ...authorisableUser,
    roles: authorisableUser.roles.filter((r) => r !== ROLE.SITE_ADMIN)
  };
}
